import styled from '@emotion/styled';
import { AuthorProfileMyme } from '@myme/api';
import { LibraryMymeProps } from '@myme/utils';
import { mq } from 'src/themes';
import { MoreOptionsMenu } from 'src/components/molecules';
import { MymePreviewDetails } from './Details';
import { MymePreviewImage } from './PreviewImage';
import { useMymePreviewOptions } from '../useMymePreviewOptions';

interface LibraryProps {
  type: 'LIBRARY';
  myme: LibraryMymeProps;
}

interface CreatorProfileProps {
  type: 'CREATOR-PROFILE';
  myme: AuthorProfileMyme;
}

type Props = LibraryProps | CreatorProfileProps;

const StyledMymePreviewContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: min-content 1fr 2rem;
  grid-template-areas: 'photo details options';

  &:not(:last-of-type) {
    margin-bottom: 1rem;
  }

  ${mq.sm} {
    grid-template-columns: min-content 1fr 1.5rem;
  }
`;

export const MymePreviewMobileVersion = (props: Props) => {
  const { libraryOptions, detailsOptions } = useMymePreviewOptions(props.myme.id);

  switch (props.type) {
    case 'LIBRARY': {
      const { myme } = props;

      return (
        <StyledMymePreviewContainer>
          <MymePreviewImage id={props.myme.id} previewImage={myme.previewImageFilePath} type={myme.type} />
          <MymePreviewDetails id={myme.id} name={myme.name} author={myme.author} progress={myme.progress} />
          <MoreOptionsMenu options={libraryOptions} />
        </StyledMymePreviewContainer>
      );
    }
    case 'CREATOR-PROFILE': {
      const { myme } = props;

      return (
        <StyledMymePreviewContainer>
          <MymePreviewImage id={props.myme.id} previewImage={myme.previewImageFilePath} type={myme.type} />
          <MymePreviewDetails
            id={myme.id}
            name={myme.name}
            author={myme.author}
            statIcons={{ likes: myme.likes, rating: myme.rating, price: myme.price }}
            hideAuthorName
          />
          <MoreOptionsMenu options={detailsOptions} />
        </StyledMymePreviewContainer>
      );
    }
    default: {
      return null;
    }
  }
};
